// extracted by mini-css-extract-plugin
export default {"childrenClass":"StudentTranscriptPreview__childrenClass___nAqAD","headerRightComponent":"StudentTranscriptPreview__headerRightComponent___yn5R7"};